import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Checkbox from '@material-ui/core/Checkbox'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

const GreenhousesFilterModal = props => {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle id="confirmation-dialog-title">Naves</DialogTitle>
      <DialogContent>
        <List>
          {props.greenhouses.map((farm, idx) => {
            return (
              <div key={'farm' + idx}>
                <ListItem
                  className={props.classes.farm}
                  key={farm.id}
                  dense
                  button
                  onClick={() => props.onChecked(null, farm.id)}>
                  <ListItemText>
                    <b>FINCA {farm.name}</b>
                  </ListItemText>
                </ListItem>

                {farm.greenhouses.map(greenhouse => {
                  return (
                    <ListItem
                      className={props.classes.greenhouse}
                      key={farm.id + '-' + greenhouse.id}
                      dense
                      button
                      disableGutters
                      onClick={() => props.onChecked(greenhouse.id)}>
                      <Checkbox
                        checked={props.selectedGreenhouses.indexOf(greenhouse.id) > -1}
                        disableRipple
                        classes={{ root: props.classes.checkbox }}
                        color="primary"
                      />
                      <ListItemText>NAVE {greenhouse.name}</ListItemText>
                    </ListItem>
                  )
                })}
              </div>
            )
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onReset}>Borrar</Button>
        <Button onClick={props.onClose} variant="contained" color="primary">
          Filtrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const styles = {
  farm: {},
  greenhouse: {
    padding: 0,
  },
  checkbox: {
    height: 30,
    '& input': {
      padding: 0,
    },
  },
}

export default withStyles(styles)(GreenhousesFilterModal)



// WEBPACK FOOTER //
// ./src/components/GreenhousesFilterModal.js